import { get } from "svelte/store";
import { type WritableFolder, isNestedDocument } from "app/models/documents";
import { v4 as uuidv4 } from "uuid";
import api from "api";

export function countAllDocs(folders: WritableFolder) {
  let count = 0;
  if (!get(folders).items) return count;
  for (const item of get(folders).items) {
    if (isNestedDocument(item) && !get(item).isDraft) {
      count++;
    } else {
      count += countAllDocs(item as WritableFolder);
    }
  }
  return count;
}

export function countAllCategories(folders: WritableFolder) {
  let count = 0;
  if (!get(folders).items) return count;
  for (const item of get(folders).items) {
    if (!isNestedDocument(item)) {
      count++;
      count += countAllCategories(item as WritableFolder);
    }
  }
  return count;
}

const getOrCreateAnonymousUserId = (): string => {
  let anonymousUserId = localStorage.getItem("anonymousUserId");
  if (!anonymousUserId) {
    anonymousUserId = uuidv4();
    localStorage.setItem("anonymousUserId", anonymousUserId);
  }
  return anonymousUserId;
};

const submitFeedbackRequest = async (
  isPositive: boolean,
  documentVersion: number,
  isAuthed: boolean
) => {
  const anonymousUserId = getOrCreateAnonymousUserId();

  await api.documentFeedbackCreate({
    // todo: make serializer retreive & submit types match, then remove ts-ignore
    // @ts-ignore
    documentFeedback: {
      ...(isAuthed ? {} : { anonymousUserId }),
      isPositive: isPositive,
      documentVersion: documentVersion,
    },
  });
  // store the feedback in local storage to prevent multiple submissions for same version
  localStorage.setItem(`feedbackDocVersion-${documentVersion}`, JSON.stringify(isPositive));
};

export const submitFeedback = async (
  isAuthed: boolean,
  isPositive: boolean,
  documentVersion: number
) => {
  const existingFeedback = localStorage.getItem(`feedbackDocVersion-${documentVersion}`);
  if (existingFeedback) {
    const feedback = JSON.parse(existingFeedback);
    if (feedback === isPositive) {
      // user has already submitted feedback for this version
      return Promise.resolve("Feedback already submitted.");
    }
  }
  return submitFeedbackRequest(isPositive, documentVersion, isAuthed);
};
